import styled from '@emotion/styled';

import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const MODAL_WIDTH = 384;

const StyledModal = styled(Modal)`
  width: ${MODAL_WIDTH}px;
`;

interface RemoveWebhookModalProp {
  onConfirm?: () => void;
  onCancel?: () => void;
}

export function RemoveWebhookModal({ onCancel, onConfirm }: RemoveWebhookModalProp): JSX.Element {
  const { t } = useTranslation();

  const onConfirmHandler = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const onCancelHandler = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <StyledModal
      appElementSelector="#root"
      contentLabel={t('common:forwarding.webhooks.remove-webhook-dialog.title')}
      isOpen
      onClose={() => onCancelHandler()}
    >
      <Modal.Header title={t('common:forwarding.webhooks.remove-webhook-dialog.title')} />
      <Modal.Body>{t('common:forwarding.webhooks.remove-webhook-dialog.body')}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={() => onCancelHandler()}>
          {t('common:forwarding.webhooks.remove-webhook-dialog.cancel')}
        </Button>
        <Button kind="danger" onClick={() => onConfirmHandler()}>
          {t('common:forwarding.webhooks.remove-webhook-dialog.confirm')}
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
}
